<template>
  <v-card class="user-history" tile>
    <v-card-title>{{ this.$t('statistics.buffer') }}</v-card-title>
    <div class="pa-2 pl-4">
      <dl class="form-box">
        <dt class="d-table-cell pt-1">{{ this.$t('statistics.category') }}</dt>
        <dd class="d-table-cell">
          <div class="d-flex align-content-start flex-wrap">
            <span class="wrap-sts-chk">
              <v-checkbox v-model="buffersVmAll" @click="toggleAll" :label="$t('statistics.buffer.checkAll')" class="sts-comp-chk-mgt-2" hide-details dense></v-checkbox>
            </span>
          </div>
          <div class="d-flex align-content-start flex-wrap">
            <span class="wrap-sts-chk" v-for="(item, idx) in options" :key="idx">
              <v-checkbox v-model="bufferVm" :label="item.text" :value="item.value" class="sts-comp-chk-mgt-2" hide-details dense></v-checkbox>
            </span>
          </div>
        </dd>
      </dl>
    </div>
  </v-card>
</template>

<script>
export default {
  props: {
    options: Array,
  },
  data() {
    return {
      buffersVmAll: false,
      bufferVm: [],
    };
  },
  watch: {
    bufferVm(val) {
      const returnVal = {
        val: Object.values(val).length > 1 ? Object.values(val).join() : val,
        title: this.$t('statistics.taskType'),
      };
      this.$emit('changeSapBuffer', { ...returnVal }, 'sapBuffer');
      this.buffersVmAll = this.options.length === val.length ? true : false;
    },
  },
  created() {
    this.allCheck();
  },
  methods: {
    allCheck() {
      this.bufferVm = [];
      this.options.map(el => this.bufferVm.push(el.value));
    },
    toggleAll() {
      !this.buffersVmAll ? (this.bufferVm = []) : this.allCheck();
    },
  },
};
</script>
